import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import { cn } from "@/utils/cn"
import { SanityImageAsset, SanityReference } from "sanity-codegen"

interface ArticleCardProps {
  size?: "md" | "lg"
  label: string
  title: string
  description: string
  image: {
    asset: SanityReference<SanityImageAsset>
  }
  className?: string
}

export function ArticleCard({
  size = "md",
  label,
  title,
  description,
  image,
  className,
}: ArticleCardProps) {
  return (
    <div
      className={cn(
        "cursor-pointer rounded-lg border-4 border-transparent transition-colors hover:border-primary-500",
        className
      )}
    >
      <SanityImageField
        asset={image.asset}
        className={cn(
          "w-full rounded-lg object-cover",
          size === "lg" ? "h-50 md:h-100" : "h-50 md:h-70"
        )}
      />
      <div className="p-6">
        <p className="font-family-gtpressura text-xs text-primary-500">
          {label}
        </p>
        <p className="mt-2 text-xlg font-semibold text-neutral-dark">{title}</p>
        <p className="mt-2 font-family-gthaptik text-md font-light text-neutral-dark">
          {description}
        </p>
      </div>
    </div>
  )
}
